import '.bx{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.m{position:absolute;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.cp{right:-4px;}.ssr-plugin'
import '.cq{width:1.5rem;}.ssr-plugin'
import '.cr{height:1.5rem;}.ssr-plugin'
import '.af{border-radius:1.25rem;}.ssr-plugin'
import '.cs{background-color:var(--primary-red);}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  onDelete,
  onCancelDelete,
}: {
  src: string
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="bx a g c"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--shades-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a g c m co cp cq cr af cs ar"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--shades-white)" />
    </div>
  )
}
